import { lazy, Suspense } from "react";

import Login from "@pages/login";
import Layout from "@layout/main-layout";

import pageRoutes from "./page-routes";
import User from "@utils/user";

const HelpList = lazy(() => import("@pages/help"));
const HelpDetail = lazy(() => import("@pages/help/detail"));
const ForgetPassword = lazy(() => import("@pages/login/forget-password"));
const ResetPassword = lazy(() => import("@pages/login/reset-password"));

const routes: any = [
  {
    path: "/login",
    name: "Login",
    element: <Login />,
  },

  {
    path: "/help-out",
    name: "Help Out",
    children: [
      {
        path: "center",
        name: "Help Center",
        element: (
          <Suspense>
            <HelpList />
          </Suspense>
        ),
      },
      {
        path: "center/detail",
        name: "Help Detail",
        element: (
          <Suspense>
            <HelpDetail />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/help-out/detail/:id",
    name: "Help Detail",
    element: (
      <Suspense>
        <HelpDetail />
      </Suspense>
    ),
  },
  {
    path: "/forget-password",
    name: "Forget Password",
    element: (
      <Suspense>
        <ForgetPassword />
      </Suspense>
    ),
  },
  {
    path: "/forget-password/reset",
    name: "Reset Password",
    element: (
      <Suspense>
        <ResetPassword />
      </Suspense>
    ),
  },
  {
    path: "/",
    element: <Layout />,
    children: [...pageRoutes],
  },
];

export default routes;
